'use client';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { HeadingBoldH1 } from '@/shared/ui/typography2';
import { WRAPPER } from '@/shared/styles/themes';
import { brandIsPh } from '@/shared/config/brand-by-target.mjs';
import {
  type PageMetadata,
  usePageMetadata,
} from '@/shared/hooks/usePageMetadata';

export const H1Content = ({
  initialMetadata,
}: {
  initialMetadata?: PageMetadata | null;
}) => {
  const { data } = usePageMetadata(initialMetadata);
  const [h1, setH1] = useState(data?.h1 ?? initialMetadata?.h1);

  useEffect(() => {
    if (data?.h1) {
      setH1(data.h1);
    }
  }, [data?.h1]);

  if (!h1) {
    return null;
  }

  return (
    <H1Wrapper><HeadingBoldH1>{h1}</HeadingBoldH1></H1Wrapper>
  );
};

const H1Wrapper = styled.div`
  ${WRAPPER}
  display: flex;
  margin: 24px 18px;
  text-align: center;
  justify-content: center;

  @media (min-width: 769px) {
    //height: 43px;
    margin: 24px auto;
  }

  @media (max-width: 768px) {
    ${brandIsPh &&
    `
      margin: 12px;
    `}
  }
`;

